import React, { Component } from "react"
import PropTypes from "prop-types"
import { observer } from "mobx-react"
// import store from "./store"
// import Service from "./services"
import "./index.scoped.less"
@observer
class Progress extends Component {
  static propTypes = {
    type: PropTypes.string,
    percent: PropTypes.number,
    text: PropTypes.string,
    textPosition: PropTypes.string,
  }

  static defaultProps = {
    type: "line",
  }

  render() {
    const { percent = 0, style, textPosition, text } = this.props
    return (
      <div className="progress progress-line progress-status-normal progress-show-info progress-default">
        <div className={`progress-text text-position-${textPosition}`}>{percent == 100 ? "完成" : text}</div>
        <div className="progress-outer">
          <div className="progress-inner">
            <div className="progress-bg" style={{ width: percent + "%", ...style }}></div>
          </div>
        </div>
      </div>
    )
  }
}
export default Progress
